import React, { useEffect, useState } from 'react';
import BaseInfo from '../../../base/info';
import CustomDropdown from '../../../base/custom-dropdown';
import { useRateStore, useResourceStore } from '../../../../store';
import AppInput from '../../../base/input';
import AppFileUpload from '../../../base/app-file-upload';
import { IActiveCountry } from '../../../../models/rate.model';

const IdentityVerification = () => {
  const { getAllCountryStates } = useResourceStore();
  const { activeCountries: countries, getActiveCountries: getAllCountries } =
    useRateStore();

  const handleFileChange = () => {
    // Handle file change logic here
    console.log('File changed');
  };

  const handleCurrencySelect = (value: any): void => {
    console.log('Selected currency:', value);
  };

  useEffect(() => {
    getAllCountries();
  }, []);
  const filteredCountries = countries.filter(
    (country) =>
      country.name === 'Nigeria' ||
      country.name === 'Ghana' ||
      country.name === 'Senegal' ||
      country.name === 'Cameroon',
  );

  const handleCountryChange = (value: { name: string; label: string }) => {
    getAllCountryStates(value.name);
  };

  return (
    <div className="p-4 rounded-xl gap-8 flex flex-col border border-[#F1F2F4] w-full h-full bg-white ">
      <div className="grid gap-6">
        <p className="ryno_text_semibold">Identification Verification</p>
        <BaseInfo
          type="information"
          text="Please provide either an identity number OR upload identity document images. Both options cannot be used simultaneously. You can upload up to 3 documents."
        />

        <div className="grid grid-cols-2 gap-8">
          <div className="col-span-2">
            <CustomDropdown
              label="Identity Country Code"
              placeholder="Select country"
              options={filteredCountries.map((country: IActiveCountry) => {
                return {
                  name: country.iso3,
                  label: country.name,
                  countryFlag: country.flagUrl,
                };
              })}
              selectedValue={''}
              onSelectChange={(value) => {
                handleCountryChange(value);
              }}
              emitObject
              required
              showCountryFlag
            />
          </div>

          <CustomDropdown
            label={'Identity Document Type'}
            options={['USD', 'EUR'].map((currency) => ({
              name: currency,
              label: currency,
            }))}
            selectedValue={''}
            onSelectChange={handleCurrencySelect}
          />

          <AppInput
            type="text"
            placeholder="Enter identification number here "
            name="accountHolderName"
            id="accountHolderName"
            value={''}
            label="Account Holder Name"
          />

          <AppFileUpload
            id="payment-receipt"
            type="file"
            label="Upload Front Side"
            onFileChange={handleFileChange}
            maxSize={4}
          />

          <AppFileUpload
            id="payment-receipt"
            type="file"
            label="Upload Back Side"
            onFileChange={handleFileChange}
            maxSize={4}
          />
        </div>
      </div>
    </div>
  );
};

export default IdentityVerification;
